// src/stores/projectStore.js
import { defineStore } from "pinia";
import { projectService } from "@/services/projectService";
import { useAppStore } from "@/stores/appStore";
import { toast } from 'vue3-toastify';

export const useProjectStore = defineStore("projectStore", {
  state: () => ({
    projects: [],
    project: null,
    loading: false,
    error: null,
  }),

  actions: {
    async getAllProjects() {
      this.loading = true;

      try {
        const response = await projectService.fetchAllProjects();
        this.projects = response.data;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2001');
      } finally {
        this.loading = false;
      }
    },

    async getProject(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await projectService.fetchProject(id);
        this.project = response.data;
        return this.project;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2002');
      } finally {
        appStore.setLoading(false);
      }
    },

    async createProject(userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await projectService.fetchCreateProject(userData);
        this.projects.push(response.data);
      } finally {
        appStore.setLoading(false);
      }
    },

    async updateProject(id, userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await projectService.fetchUpdateProject(id, userData);
        const index = this.projects.findIndex((b) => b.id === id);
        if (index !== -1) this.projects[index] = response.data;
      } finally {
        appStore.setLoading(false);
      }
    },

    async deleteProject(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        await projectService.fetchDeleteProject(id);
        this.projects = this.projects.filter((b) => b.id !== id);
        toast.success("Success");
      } catch (error) {
        toast.error(error.response.data.message + ' - 2003');
      } finally {
        appStore.setLoading(false);
      }
    },
  },
});
